module.exports = __webpack_public_path__ + "static/media/glycan-icon.a236ddb2.svg";